import React from 'react'

function SubFilters(props) {
  const { filterDisableWithoutSelect, getMoviesFilterData, resethandle } = props
  return (
    <div className='filterreset' style={{ marginTop: '10px' }}>
      <div>
        <div className=''>
          <button
            disabled={!filterDisableWithoutSelect}
            style={{ marginRight: '10px' }}
            type='button'
            onClick={() => getMoviesFilterData()}
            className='btn btn-primary'
          >
            filter
          </button>{' '}
        </div>{' '}
      </div>
      <div>
        <div className=''>
          <button
            // disabled={statusType === 'draft'}
            type='button'
            className='btn btn-primary'
            onClick={() => resethandle()}
          >
            reset
          </button>
        </div>
      </div>
    </div>
  )
}

export default SubFilters
